var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobRunFailedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21444_23935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60913 0.757812C3.86187 0.757812 0 4.61968 0 9.36694C0 14.1142 3.86187 17.9761 8.60913 17.9761C13.3564 17.9761 17.2183 14.1142 17.2183 9.36694C17.2183 4.61968 13.3564 0.757812 8.60913 0.757812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7793 11.5229C12.0598 11.8035 12.0598 12.2568 11.7793 12.5374C11.6394 12.6773 11.4558 12.7476 11.272 12.7476C11.0884 12.7476 10.9047 12.6773 10.7648 12.5374L8.60898 10.3814L6.45315 12.5374C6.31325 12.6773 6.1296 12.7476 5.94595 12.7476C5.76217 12.7476 5.57852 12.6773 5.43862 12.5374C5.15816 12.2568 5.15816 11.8035 5.43862 11.5229L7.59458 9.36704L5.43862 7.21121C5.15816 6.93061 5.15816 6.47727 5.43862 6.19668C5.71922 5.91621 6.17256 5.91621 6.45315 6.19668L8.60898 8.35264L10.7648 6.19668C11.0454 5.91621 11.4987 5.91621 11.7793 6.19668C12.0598 6.47727 12.0598 6.93061 11.7793 7.21121L9.62338 9.36704L11.7793 11.5229Z",
    fill: "#FD3757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21444_23935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2183,
    height: 17.2183,
    fill: "white",
    transform: "translate(0 0.757812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobRunFailedIcon);
export default __webpack_public_path__ + "static/media/JobRunFailedIcon.7fba61e08c6e0fd2fb6d3b104a33e119.svg";
export { ForwardRef as ReactComponent };